import type { Locale } from "@tutor/protocol";
import generated from "./generated/skill-titles.json";

// Skill names for clients, in every locale. Generated from content/ by
// `pnpm --filter @tutor/curriculum titles` (test/titles.test.ts fails when it drifts), so
// the learner app can name a skill without bundling items, answers or hints.

/** Skill id → its title in each locale. */
export type SkillTitles = Readonly<Record<string, Readonly<Record<Locale, string>>>>;

export const SKILL_TITLES: SkillTitles = generated;
